import { Dropdown } from "@design-system/Inputs/UniversalDropdown";
import { Box } from "@design-system/Layout/Box";
import { Modal } from "@design-system/Modal";
import { type FC, type PropsWithChildren, useState } from "react";
import { DeleteConfirmationModalContent } from "./DeleteConfirmationModalContent";
import { EditQuestionnaireModal } from "./EditQuestionnaireModal";
import { useEditOrDeleteDropdownTranslations } from "./i18n";
export const EditOrDeleteDropdown: FC<
    PropsWithChildren<{
        questionnaireId?: string;
    }>
> = ({ questionnaireId, children }) => {
    const { t, keys } = useEditOrDeleteDropdownTranslations();

    const [openEditModal, setOpenEditModal] = useState(false);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);

    const openEditModalOnClick = () => {
        setOpenEditModal(true);
    };

    const openDeleteModalOnClick = () => {
        setOpenDeleteModal(true);
    };

    return (
        <Box display="grid" className="place-items-center">
            <Dropdown>
                <Dropdown.Trigger asChild>{children}</Dropdown.Trigger>
                <Dropdown.Content hasPortal>
                    <Dropdown.Item onClick={openEditModalOnClick}>
                        <Dropdown.ItemIcon name="edit" />
                        <Dropdown.ItemText>
                            {t(keys.edit_questionnaire_modal_title)}
                        </Dropdown.ItemText>
                    </Dropdown.Item>
                    <Dropdown.Item
                        variant="negative"
                        onClick={openDeleteModalOnClick}
                    >
                        <Dropdown.ItemIcon name="trash" />
                        <Dropdown.ItemText>
                            {t(keys.delete_questionnaire_modal_title)}
                        </Dropdown.ItemText>
                    </Dropdown.Item>
                </Dropdown.Content>
            </Dropdown>
            <EditQuestionnaireModal
                questionnaireId={questionnaireId}
                open={openEditModal}
                onOpenChange={setOpenEditModal}
            />
            <Modal open={openDeleteModal} onOpenChange={setOpenDeleteModal}>
                <Modal.Overlay centerContent>
                    <DeleteConfirmationModalContent
                        questionnaireId={questionnaireId}
                    />
                </Modal.Overlay>
            </Modal>
        </Box>
    );
};
